import type { UsedFinanceInsurancePayload } from "../../utils/financeUtils";
import type { UscInsuranceQuoteType } from "../../utils/insuranceUtils";

export const INSURANCE_SET_QUOTE = "insurance/setInsuranceQuote";
export const INSURANCE_SET_FAILED = "insurance/setFailed";
export const INSURANCE_SET_QUOTE_ID = "insurance/setInsuranceQuoteId";

export type SetInsuranceQuote = {
    type: typeof INSURANCE_SET_QUOTE;
    quote: UscInsuranceQuoteType | null;
    payload: UsedFinanceInsurancePayload | null;
};
type SetFinanceFailed = {
    type: typeof INSURANCE_SET_FAILED;
    failed: boolean;
    payload: UsedFinanceInsurancePayload | null;
};
type SetInsuranceQuoteId = {
    type: typeof INSURANCE_SET_QUOTE_ID;
    insuranceQuoteId: string;
};

export const setInsuranceQuote = (
    quote: UscInsuranceQuoteType | null,
    payload: UsedFinanceInsurancePayload | null = null,
): SetInsuranceQuote => ({
    type: INSURANCE_SET_QUOTE,
    quote,
    payload,
});

export const setInsuranceFailed = (
    failed: boolean,
    payload: UsedFinanceInsurancePayload | null = null,
): SetFinanceFailed => ({
    type: INSURANCE_SET_FAILED,
    failed,
    payload,
});

export const setInsuranceQuoteId = (insuranceQuoteId: string): SetInsuranceQuoteId => ({
    type: INSURANCE_SET_QUOTE_ID,
    insuranceQuoteId,
});

export type UscInsuranceActionsType = SetInsuranceQuote | SetFinanceFailed | SetInsuranceQuoteId;
